import React from 'react';

export default function PricingTierCard({ title, amount, bullets = [], impact, selected, onSelect }) {
  return (
    <div className={`ps-card ps-tier-card ${selected ? 'is-selected' : ''}`}>
      <div className="ps-tier-header">
        <h3>{title}</h3>
        <div className="ps-tier-amount">{amount}</div>
      </div>
      <ul className="ps-tier-list">
        {bullets.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
      <div className="ps-tier-impact">{impact}</div>
      <button type="button" className="btn ps-btn-primary btn-sm" onClick={onSelect}>
        Choose this
      </button>
    </div>
  );
}
